import { Box, TableContainer } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import SearchBar from "components/SearchBar";
import TableComponent from "components/TableComponent";
import React, { useState } from "react";

const BookingHistory = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [count, setCount] = useState<number>(1);
  const [page, setPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const onPageChange = (e: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const rows = [
    {
      id: 1,
      vehicleType: 1,
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      approvalStatus: 1,
    },
    {
      id: 2,
      vehicleType: 2,
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      approvalStatus: 2,
    },
  ];

  const columns: GridColDef[] = [
    {
      flex: 0.4,
      minWidth: 100,
      field: "id",
      headerName: "Booking ID",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{"#101"}</p>
          </div>
        );
      },
    },

    {
      flex: 0.6,
      minWidth: 100,
      field: "booking",
      headerName: "Booking Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: "16px" }}>
            <figure style={{ cursor: "pointer" }} onClick={() => {}}>
              <img src={"/static/images/vehicle_side.jpg"} alt="Vehicle" />
            </figure>
            <p>
              <b>Ford Mustang</b>
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.8,
      minWidth: 200,
      field: "owner",
      headerName: "Owner Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={"/static/images/user_placeholder.png"} alt="" />
            </figure>
            <p>
              <b>{"John"}</b>
              {"+971"} {"99229922"} <br />
              {"test@yopmail.com"}
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "price",
      headerName: "Price",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{"AED 2000"}</p>
          </div>
        );
      },
    },

    {
      flex: 0.6,
      minWidth: 200,
      field: "date",
      headerName: "Date & Time",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {"From: 1 Jul, 2015 2:00pm"} <br />{" "}
              {"To: 1 Jul, 2015 2:00pm"}{" "}
            </p>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="invitedPersons_info">
        <TableContainer className="table_container">
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search"
                />
              </Box>
            </div>
          </div>

          <div className="sorting_table">
            {rows && (
              <TableComponent
                columns={columns}
                rows={rows}
                count={count}
                page={page}
                onPageChange={onPageChange}
                loading={isLoading}
              />
            )}
          </div>
        </TableContainer>
      </div>
    </>
  );
};

export default BookingHistory;
